// utils/confirm-delete.ts — Modale de confirmation de suppression (glu DOM).
//
// Factorise le pattern répété par entité (plan, phase, structure, …) :
// openModal → corps « <label> » → appel API DELETE → closeModal + succès, OU
// toast d'erreur (le message backend du 409 « entité non vide » est conservé).
// Extrait juin 2026. `openModal/closeModal/toast/t/esc` sont des globals ambiants.

export interface ConfirmDeleteOpts {
  /** Clé i18n du titre de la modale. */
  titleKey: string;
  /** Clé i18n du corps ; reçoit `bodyParams` (typiquement `{ label }`). */
  bodyKey: string;
  bodyParams?: Record<string, unknown>;
  /** Clé i18n du bouton de confirmation (défaut `common.delete`). */
  confirmKey?: string;
  /** L'appel API de suppression (n'importe quel retour). */
  onDelete: () => Promise<unknown>;
  /** Exécuté APRÈS succès + fermeture : toast de succès + maj locale + re-render. */
  onDeleted: () => void;
}

export function confirmDelete(o: ConfirmDeleteOpts): void {
  openModal(
    t(o.titleKey),
    `<p>${esc(t(o.bodyKey, o.bodyParams ?? null))}</p>`,
    async () => {
      try {
        await o.onDelete();
        closeModal();
        o.onDeleted();
      } catch (err: unknown) {
        // 409 si l'entité est encore liée → message backend explicite conservé.
        toast(err instanceof Error ? err.message : t('common.error'), 'error');
      }
    },
    t(o.confirmKey ?? 'common.delete'),
  );
}
